/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".alertpage_form[_ngcontent-%COMP%] > form[_ngcontent-%COMP%] > button[_ngcontent-%COMP%]{margin-top:2.5rem}.alertpage_form[_ngcontent-%COMP%]   .mat100[_ngcontent-%COMP%]{display:inline-block!important}\n/*# sourceMappingURL=edit-subscription.component.css.map*/"];
export { styles as styles };
